"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
// Checks if value is already registered to an account
exports.uniqueCheck = (username, IDMbaseurl) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMbaseurl + '/openidm/endpoint/uniqueCheck';
    const headers = {
        'X-OpenIDM-Password': 'anonymous',
        'X-OpenIDM-Username': 'anonymous',
        'Content-Type': 'application/json'
    };
    const body = {
        'username': username
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        data: body,
        url
    }).then(response => handleUniqueCheckResponse(response)).catch(err => handleIDMError(err));
});
// Creates a local password for a socially registered user
exports.createPassword = (code, username, password, IDMbaseurl) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMbaseurl + '/openidm/endpoint/makePassword';
    const headers = {
        'X-OpenIDM-Password': 'anonymous',
        'X-OpenIDM-Username': 'anonymous',
        'Content-Type': 'application/json'
    };
    const body = {
        'code': code,
        'username': username,
        'password': password
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        data: body,
        url
    }).then(response => handleCreatePasswordResponse(response))
        .catch(err => handleIDMError(err));
});
const handleUniqueCheckResponse = (resp) => __awaiter(void 0, void 0, void 0, function* () {
    // Success case
    if (resp.data.code === 200) {
        return {
            'code': 200,
            'resp': resp,
            'state': {
                'available': true
            }
        };
    }
    else if (resp.data.code === 418) {
        // Invalid code case, let the UI know
        return {
            'code': 418,
            'resp': resp,
            'state': {
                'available': false
            }
        };
    }
    else {
        // Unexpected, non-erroneous response from IDM. This is invalid, so let the UI know.
        return {
            'code': 500,
            'resp': resp,
            'state': {
                'available': false
            }
        };
    }
});
const handleCreatePasswordResponse = (resp) => __awaiter(void 0, void 0, void 0, function* () {
    // Success case
    if (resp.data.code === 200) {
        return {
            'code': 200,
            'resp': resp
        };
    }
    else if (resp.data.code === 401) {
        // Invalid code case, let the UI know
        return {
            'code': 401,
            'resp': resp
        };
    }
    else if (resp.data.code === 403) {
        return {
            'code': 403,
            'resp': resp
        };
    }
    else {
        // Unexpected, non-erroneous response from IDM. This is invalid, so let the UI know.
        return {
            'code': 400,
            'resp': resp
        };
    }
});
const handleIDMError = (error) => {
    // set state loading false and responseValid false
    return {
        'code': 400,
        'resp': error
    };
};
